// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Ep-z","breadcrumbForward":"Fp-z","breadcrumbBack":"Gp-z","selected":"Hp-z"};